export const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_INFO: 'user_info',
  COOKIE: 'auth_cookie',
  SETTINGS: 'global_settings',
  BUSINESS_UNITS: 'business_units',
};

export const SESSION_STORAGE_KEYS = {
  CAMPAIGN_CREATION_DATA: 'campaign_creation_data',
  LINE_ITEM_DATA: 'line_item_data',
  CURRENT_STEP: 'current_step',
  CURRENT_CAMPAIGN_TYPE: 'current_campaign_type',
  TARGETING_DATA: 'targeting_data',
  DRAFT_ID: 'draft_id',
  LINE_ITEM_COUNT: 'line_item_count',
  CREATE_CAMPAIGN_MODE: 'create_campaign_mode',
};
